import React, { useContext, Fragment, useEffect } from "react";
import { ProdutoContext } from "../ProdutoContext";
import Pesquisar from "../../../../../Components/Cadastro/Pesquisar/Pesquisar";
import TabelaResultados from "../../../../../Components/Cadastro/TabelaResultados/TabelaResultados";

const PesquisarProduto = () => {
  const { values, setValues, resetScreen } = useContext(ProdutoContext);

  useEffect(() => {
    resetScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      searchData: {
        ...values.searchData,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Pesquisar context={ProdutoContext}>
        <div className="col-12 col-md-2">
          <label>Código do Produto</label>
          <input
            className="form-control"
            type="text"
            name="produtoCod"
            value={values.searchData.produtoCod}
            onChange={onChangeInput}
          />
        </div>

        <div className="col-12 col-md-4">
          <label>Nome do Produto</label>
          <input
            className="form-control"
            type="text"
            name="produtoNome"
            value={values.searchData.produtoNome}
            onChange={onChangeInput}
          />
        </div>
      </Pesquisar>
      <TabelaResultados context={ProdutoContext} />
    </Fragment>
  );
};

export default PesquisarProduto;
